<app-header></app-header>

<main class="base__content">
  <router-outlet></router-outlet>
</main>
